import { createContext, useContext, useState, ReactNode } from 'react'

export type Page = '/' | '/habit' | '/weekly' | '/tasks' | '/finance' | '/settings'

export interface NavigationContextType {
  currentPage: Page
  navigate: (page: Page) => void
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined)

export function NavigationProvider({ children }: { children: ReactNode }): JSX.Element {
  const [currentPage, setCurrentPage] = useState<Page>('/')

  const value: NavigationContextType = {
    currentPage,
    navigate: setCurrentPage,
  }

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  )
}

export function useNavigation(): NavigationContextType {
  const context = useContext(NavigationContext)
  if (!context) {
    throw new Error('useNavigation must be used within NavigationProvider')
  }
  return context
}
